import toast from "react-hot-toast";

export default (error: any) => {
  handleOpenConfirmLogoutBox();
  toast.error('Request failed , endpoint not found', {
    position: 'top-left',
    duration: 5000,
  });
}

const handleOpenConfirmLogoutBox = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('role');
  localStorage.removeItem('userId');
  window.location.href = '/login';
};